<div class="container container-responsive mt-5 mb-5">
    <div class="row mt-2">
        <div class="col-12 col-md-3" *ngIf="!hideProfileSidebar">
            <aside class="col-auto sidebar rounded-4 p-3 pb-5 bg-white">
                <div class="profile text-center mb-2 pt-4">
                    <div class="text-center">
                        <span class="avatar rounded-circle d-flex align-items-center justify-content-center syne-text"
                            routerLink="/profile/edit-page">
                            {{ getUserName(currentUser) | uppercase }}
                        </span>
                        <div>
                            <span class="edit syne-text fw-medium fs-20" routerLink="/profile/edit-page">
                                {{ [1, 4, 6].includes(currentUser?.RoleId)? formatName(currentUser?.CompanyName):
                                formatName(currentUser?.FirstName)}}
                                <i class="skf-icon skf-pencil ms-1"></i>
                            </span>
                        </div>
                        <button *ngIf="currentUser?.RoleId !== 2 && currentUser?.RoleId !== 3"
                            (click)="getFeatureStatus()" class="btn btn-primary mt-4 rounded-pill syne-text w-75"
                            data-bs-toggle="modal" data-bs-target="#publishContentMenu">
                            <span class="d-flex align-items-center justify-content-center">
                                <i class="skf-icon skf-plus fs-16 me-1"></i>{{ 'publish' | translate }}
                            </span>
                        </button>
                        <button *ngIf="currentUser?.RoleId == 1 || currentUser?.RoleId == 6" (click)="gotoCompanyPage()"
                            class="btn btn-outline-secondary rounded-pill mt-3 fs-16 syne-text w-100 d-flex align-items-center justify-content-center">
                            <i class="skf-icon skf-eye me-1"></i> {{ 'view_as_user' | translate }}
                        </button>
                    </div>
                </div>
                <nav class="nav flex-column fs-16 p-2">
                    <a class="nav-link mb-1" *ngIf="currentUser?.RoleId == 1 || currentUser?.RoleId == 6"
                        routerLink="/profile/edit-content" routerLinkActive="active">
                        <i class="skf-icon skf-location-check me-3"></i> {{ 'contents' | translate}}
                    </a>
                    <!-- <a *ngIf="currentUser?.RoleId !== 1 && currentUser?.RoleId !== 6" class="nav-link mb-1"
                        routerLink="/profile/dashboard" routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }">
                        <i class="skf-icon skf-home me-3"></i> {{ 'dashboard' | translate}}
                    </a> -->
                    <a class="nav-link mb-1" routerLink="/profile/analytics" routerLinkActive="active"
                        *ngIf="currentUser?.RoleId == 1 || currentUser?.RoleId == 6">
                        <i class="skf-icon skf-analytics me-3"></i> {{ 'analytics' | translate }}
                    </a>
                    <a class="nav-link mb-1" routerLink="/profile/edit-page" routerLinkActive="active">
                        <i class="skf-icon skf-edit me-3"></i> {{ 'profile' | translate }}
                    </a>
                    <!-- <a class="nav-link mb-1" routerLink="/newsletter" routerLinkActive="active"
                        *ngIf="currentUser.RoleId !== 1 && currentUser.RoleId !== 6">
                        <i class="skf-icon skf-open-envelope me-3"></i> {{ 'newsletter' | translate }}
                    </a> -->
                    <a class="nav-link mb-1" *ngIf="currentUser?.RoleId == 1" routerLink="/profile/my-subscription"
                        routerLinkActive="active">
                        <i class="skf-icon skf-tag me-3"></i> {{'my_subscription' | translate}}
                    </a>
                    <!-- <a class="nav-link mb-1">
                        <i class="skf-icon skf-save me-3"></i> {{ 'saved' | translate }}
                    </a> -->
                    <a class="nav-link mb-1" routerLink="/profile/follow-page" routerLinkActive="active">
                        <i class="skf-icon skf-copy-plus me-3"></i> {{ 'following' | translate }}
                    </a>
                    <a class="nav-link mb-1" *ngIf="currentUser?.RoleId == 1 || currentUser?.RoleId == 6"
                        routerLink="/profile/followers-page" routerLinkActive="active">
                        <i class="skf-icon skf-follower me-3"></i> {{ 'followers' | translate }}
                    </a>

                    <hr class="black-line">
                    <a class="nav-link mb-1" routerLink="/profile/setting" routerLinkActive="active">
                        <i class="skf-icon skf-settings me-3"></i> {{ 'settings' | translate }}
                    </a>
                    <a class="nav-link mb-1" routerLink="/profile/help-center" routerLinkActive="active">
                        <i class="skf-icon skf-help me-3"></i> {{ 'help_center' | translate}}
                    </a>
                </nav>
            </aside>
        </div>
        <div [class.col-md-9]="!hideProfileSidebar" [class.col-12]="hideProfileSidebar">
            <main class="col w-100">
                <ng-container>
                    <router-outlet (activate)="onChildActivate($event)">
                    </router-outlet>
                </ng-container>
            </main>
        </div>
        <div class="mt-4" *ngIf="plansData && router.url.includes('my-subscription')" id="plansSection">
            <div class="col-12">
                <div class="card p-4 rounded-4 border-0">
                    <div class="syne-text fs-25 fw-semibold">
                        {{'compare_plans' | translate}}
                    </div>

                    <div class="text-muted fs-16 pb-4 mb-5">
                        {{'evaluate_plan_options' | translate}}
                    </div>
                    <app-company-plans [plans]="plansData.plans" [activePlanUid]="plansData.activePlanUid"
                        [featureRows]="plansData.featureRows" [isRegister]="false">
                    </app-company-plans>
                </div>
            </div>
<!-- 
            <div class="col-12 mt-4" id="marketingActionsSection">
                <app-marketing-actions></app-marketing-actions>
            </div> -->
        </div>
    </div>
</div>

<div class="modal fade" id="publishContentMenu" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered" [ngClass]="{ 'modal-lg': currentUser?.RoleId === 1 }">
        <div class="modal-content p-4 rounded-4">
            <button type="button" class="btn-close ms-auto fs-15" data-bs-dismiss="modal"></button>
            <div *ngIf="currentUser?.RoleId === 1" class="px-5 p-1 mb-3">
                <div>
                    <div class="fw-semibold text-center syne-text fs-32 mb-2">
                        {{ 'what_do_you_want_to_pubslish' | translate }}
                    </div>

                    <p class=" text-center mb-3 fs-16 px-3">
                        {{ 'share_content' | translate }}
                    </p>

                    <hr>

                    <div class="row g-3">
                        <div class="publish-grid mt-4">

                            <div class="publish-card d-flex text-center justify-content-center align-items-center rounded-4"
                                [routerLink]="['/profile/publish-content/product-texture/product']" onkeyup=""
                                data-bs-dismiss="modal" onkeyup="">
                                <i class="skf-icon skf-3d-view mb-3"></i>
                                <span class="fs-16">{{ 'bim_object' | translate }}</span>
                            </div>

                            <div class="publish-card position-relative d-flex text-center justify-content-center align-items-center rounded-4"
                                [class.locked]="isLocked('articles')"
                                (click)="handlePublish('articles', '/profile/publish-content/news')" onkeyup="">
                                <i class="skf-privacy fs-18" *ngIf="isLocked('articles')" title="Upgrade to unlock">
                                </i>
                                <i class="skf-icon skf-news mb-3"></i>
                                <span class="fs-16">{{ 'article' | translate }}</span>
                            </div>

                            <div class="publish-card position-relative d-flex text-center justify-content-center align-items-center rounded-4"
                                (click)="handlePublish('company_videos', '/profile/publish-content/video')" onkeyup="">
                                <i class="skf-icon skf-video mb-3"></i>
                                <span class="fs-16">{{ 'corporate_video' | translate }}</span>
                            </div>

                            <div class="publish-card position-relative d-flex text-center justify-content-center align-items-center rounded-4"
                                [class.locked]="isLocked('post')" (click)="handlePublish('post', '')" onkeyup="">
                                <i class="skf-privacy fs-18" *ngIf="isLocked('post')" title="Upgrade to unlock"></i>
                                <i class="skf-icon skf-post mb-3"></i>
                                <span class="fs-16">{{'post' | translate }}</span>
                            </div>

                            <div class="publish-card position-relative d-flex text-center justify-content-center align-items-center rounded-4"
                                data-bs-dismiss="modal"
                                (click)="handlePublish('catalogues', '/profile/publish-content/catalogue')" onkeyup="">
                                <i class="skf-icon skf-catalogue mb-3"></i>
                                <span class="fs-16">{{ 'catalogue' | translate }}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="currentUser?.RoleId !== 1" class="mx-2">
                <div class="fw-medium text-center fs-32 syne-text mb-3 mx-3">
                    {{'publish_not_possible' | translate}}
                </div>
                <p class="text-muted fs-16 text-center mb-3 mx-auto">
                    {{'publishing_coming_soon' | translate}}
                </p>
                <div class="w-90 mx-auto d-flex justify-content-center fs-16 my-4">
                    {{'wait_almost_over' | translate}}
                </div>
            </div>

        </div>
    </div>
</div>


<div class="modal fade" id="profileLimitInfoModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-4 rounded-4">
            <button type="button" class="btn-close ms-auto fs-15" data-bs-dismiss="modal"></button>

            <div class="mx-2 p-3">
                <div class="fw-medium text-center fs-32 syne-text mb-3">
                    {{ modalData.title }}
                </div>

                <div class="text-muted fs-16 text-center mb-1 mx-auto">
                    {{ modalData.message1 }}
                </div>
                <div class="text-muted fs-16 text-center mb-3 mx-auto">
                    {{ modalData.message2 }}
                </div>
            </div>

        </div>
    </div>
</div>

<app-add-update-post *ngIf="isPost" (postPublished)="onPublishedPost()" [isEditMode]="false"
    (closeModal)="hidePostModal()"></app-add-update-post>
